import { useBeforeUnload, useLocation } from 'react-router-dom'
import React, { useEffect } from 'react'

/**
 * Using react router we create an effect when the page was loaded and when the page was unloaded
 * @param onLoad - the event to run when the page loads
 * @param onUnload - the event to run when the page unloads
 */

export const usePageLifecycle = (onLoad: () => void, onUnload: () => void) => {
  const location = useLocation()

  useEffect(() => {
    if (onLoad) onLoad() // Run when the page loads
    return () => {
      if (!onUnload) return
      return onUnload() //when the user navigated away
    }
    // onLoad/onUnload intentionally excluded: callers (e.g. useDocumentLock) pass new inline functions
    // every render, so including them would re-run this effect — firing onLoad and the onUnload cleanup
    // — on every render instead of only on an actual route change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]) // Runs when the route changes

  useBeforeUnload(
    React.useCallback(() => {
      if (!onUnload) return
      return onUnload()
    }, [onUnload])
  )
}
